import { RadioGroupProps } from ".";
import {
	Radio,
	FormLabel,
	FormControl,
	FormHelperText,
	FormControlLabel,
	RadioGroup as BaseRadioGroup,
} from "@mui/material";

export default function RadioGroup({
	error,
	helperText,
	label = "",
	values = [],
	...rest
}: RadioGroupProps) {
	return (
		<FormControl>
			<FormLabel id={`radio-group-${label.toLowerCase()}`}>
				{label}
			</FormLabel>
			<BaseRadioGroup
				name="radio-group"
				aria-labelledby={`radio-group-${label.toLowerCase()}`}
				{...rest}
			>
				{values.map(({ value, label }, i) => (
					<FormControlLabel
						key={i}
						value={value}
						label={label}
						control={<Radio />}
						sx={{ height:"30px"}}
					/>
				))}
			</BaseRadioGroup>
			<FormHelperText sx={{ color: "#ff0000" }}>
				{helperText}
			</FormHelperText>
		</FormControl>
	);
}
